import React from 'react';
import QueryProvider from '@/modules/QueryProvider';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import TaskListView, {
  TaskFilterParams,
  TaskSortableFields,
  TasksProvider,
} from '@/modules/Tasks';

function ConstituentTasksTab() {
  return (
    <QueryProvider
      filterParams={TaskFilterParams}
      sortableFields={TaskSortableFields}
      isPaginated
    >
      <TasksProvider>
        <TaskListView />
      </TasksProvider>
    </QueryProvider>
  );
}

export default ConstituentTasksTab;
